@if (authenticationService.isLoggedIn) {
  <mat-toolbar class="main-toolbar header">
    <mat-toolbar-row>
      <div class="with-icon logo" [routerLink]="getRouterLink()">
        @if (logoService.loading) {
          <div class="loading">
            <mat-spinner diameter=25></mat-spinner>
          </div>
        } @else {
          @if (organizationData.missingLogo) {
            <div>
              <img alt="logo"
                src="assets/images/header.png">
              </div>
            } @else {
              <img (error)="organizationData.missingLogo = true; logoService.loading = false"
                [src]="organizationData.logoUrl"
                alt="logo">
            }
          }
        </div>
        <div class="header__navigation">
          <div class="header__navigation--desktop">
            @if (authenticationService.showNavigation()) {
              <div class="left">
                @if (authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('DASHBOARD_VIEW', 'CONTRIBUTION_REPORT_VIEW', 'FORM_SUMMARY_REPORT', 'REPORT_BUILDER','QRVEY_REPORTS','GRAFANA') | async) {
                  <div class="nav-link-wrapper"
                    >
                    @if (permissionService.hasPermission('DASHBOARD_VIEW')) {
                      <a class="nav-link"
                        [routerLink]=getRouterLink()
                        routerLinkActive="active">
                        {{'Reports' | translate}}
                      </a>
                    } @else {
                      @if (authenticationService.isNotAnAgent() && permissionService.hasPermission('CONTRIBUTION_REPORT_VIEW')) {
                        <a
                          class="nav-link"
                          routerLink="/reporting/contribution"
                          routerLinkActive="active">
                          {{'Reports' | translate}}
                        </a>
                      } @else {
                        <ng-template [ngTemplateOutlet]="noDashboard"></ng-template>
                      }
                    }
                    <ng-template #noDashboard>
                      @if (authenticationService.isNotAnAgent() && permissionService.hasPermission('CONTRIBUTION_REPORT_VIEW')) {
                        <a
                          class="nav-link"
                          routerLink="/reporting/contribution"
                          routerLinkActive="active">
                          {{'Reports' | translate}}
                        </a>
                      } @else {
                        @if (authenticationService.isNotAnAgent() && permissionService.hasPermission('CONTRIBUTION_REPORT_VIEW')) {
                          <a
                            class="nav-link"
                            routerLink="/reporting/contribution"
                            routerLinkActive="active">
                            {{'Reports' | translate}}
                          </a>
                        } @else {
                          <ng-template [ngTemplateOutlet]="noDashboard"></ng-template>
                        }
                      }
                    </ng-template>
                    <div class="submenu">
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showStandardLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/11')"
                          (mouseenter)="prefetchLookerSession('11')"
                          routerLinkActive="active">
                          {{'Usage Retail' | translate}}
                        </a>
                      }
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showStandardLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/13')"
                          (mouseenter)="prefetchLookerSession('13')"
                          routerLinkActive="active">
                          {{'Product Insight' | translate}}
                        </a>
                      }
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showStandardLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/15')"
                          (mouseenter)="prefetchLookerSession('15')"
                          routerLinkActive="active">
                          {{'Customer Journey' | translate}}
                        </a>
                      }
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showBypLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/27')"
                          (mouseenter)="prefetchLookerSession('27')"
                          routerLinkActive="active">
                          {{'BYP - Executive Dashboard' | translate}}
                        </a>
                      }
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showBypLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/28')"
                          (mouseenter)="prefetchLookerSession('28')"
                          routerLinkActive="active">
                          {{'BYP - Interactions Dashboard' | translate}}
                        </a>
                      }
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showBypLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/27')"
                          (mouseenter)="prefetchLookerSession('27')"
                          routerLinkActive="active">
                          {{'BYP - Executive Dashboard' | translate}}
                        </a>
                      }
                      @if ((permissionService.hasPermission('GRAFANA') | async) && showBypLookerDashboards()) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          (click)="navigateAndRefresh('/reporting/dashboard/28')"
                          (mouseenter)="prefetchLookerSession('28')"
                          routerLinkActive="active">
                          {{'BYP - Interactions Dashboard' | translate}}
                        </a>
                      }
                    </div>
                  </div>
                }
                @if (authenticationService.isNotAnAgent()) {
                  <div class="nav-link-wrapper">
                    @if (permissionService.hasPermission('USER_VIEW') | async) {
                      <a
                        class="nav-link"
                        routerLink="/users"
                        routerLinkActive="active">
                        {{'Users' | translate}}
                      </a>
                    }
                    <div class="submenu">
                      @if (permissionService.hasPermission('USER_VIEW') | async) {
                        <a
                          [routerLinkActiveOptions]="{exact: true}"
                          class="nav-link"
                          routerLink="/users"
                          routerLinkActive="active">
                          {{'Users' | translate}}
                        </a>
                      }
                      <!--              <a *ngIf="permissionService.hasPermission('GROUP_VIEW') | async"-->
                      <!--                 [routerLinkActiveOptions]="{exact: true}"-->
                      <!--                 class="nav-link"-->
                      <!--                 routerLink="/users/groups"-->
                      <!--                 routerLinkActive="active">-->
                      <!--                {{'Groups' | translate}}-->
                    <!--              </a>-->
                    <!--              <a *ngIf="permissionService.hasPermission('TASK_VIEW') | async"-->
                    <!--                 [routerLinkActiveOptions]="{exact: true}"-->
                    <!--                 class="nav-link"-->
                    <!--                 routerLink="/users/tasks"-->
                    <!--                 routerLinkActive="active">-->
                    <!--                {{'Tasks' | translate}}-->
                  <!--              </a>-->
                  @if (permissionService.hasPermission('USER_VIEW') | async) {
                    <a
                      [routerLinkActiveOptions]="{exact: true}"
                      class="nav-link"
                      routerLink="/users/roles"
                      routerLinkActive="active">
                      {{'Business Roles' | translate}}
                    </a>
                  }
                  @if (organizationData.canUpdatePermissions) {
                    <a
                      [routerLinkActiveOptions]="{exact: true}"
                      class="nav-link"
                      routerLink="/permissions"
                      routerLinkActive="active">
                      {{'Permissions' | translate}}
                    </a>
                  }
                </div>
              </div>
            }
            <div class="nav-link-wrapper">
              @if (authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('STORE_VIEW', 'CONTACT_VIEW', 'ACCOUNT_VIEW', 'SALES_GOALS_TYPE_VIEW') | async) {
                <a
                  class="nav-link" routerLink="/stores" routerLinkActive="active">
                  {{labelingService.getStoresLabel() | async}}
                </a>
              }
              <div class="submenu">
                @if (permissionService.hasPermission('STORE_VIEW') | async) {
                  <a
                    [routerLinkActiveOptions]="{exact: true}"
                    class="nav-link"
                    routerLink="/stores"
                    routerLinkActive="active">
                    {{labelingService.getStoresLabel() | async}}
                  </a>
                }
                @if (permissionService.hasPermission('ACCOUNT_VIEW') | async) {
                  <a
                    [routerLinkActiveOptions]="{exact: true}"
                    class="nav-link"
                    routerLink="/stores/accounts"
                    routerLinkActive="active">
                    {{labelingService.getAccountsLabel() | async}}
                  </a>
                }
                @if (permissionService.hasPermission('STORE_DESIGNATION_VIEW') | async) {
                  <a
                    [routerLinkActiveOptions]="{exact: true}"
                    class="nav-link"
                    routerLink="/stores/designations"
                    routerLinkActive="active">
                    {{labelingService.getStoreDesignationsLabel() | async}}
                  </a>
                }
                @if (permissionService.hasPermission('STORE_TYPE_VIEW') | async) {
                  <a
                    [routerLinkActiveOptions]="{exact: true}"
                    class="nav-link"
                    routerLink="/stores/types"
                    routerLinkActive="active">
                    {{labelingService.getStoreTypesLabel() | async}}
                  </a>
                }
                <!--              <a *ngIf="permissionService.hasPermission('SALES_GOALS_TYPE_VIEW') | async"-->
                <!--                [routerLinkActiveOptions]="{exact: true}"-->
                <!--                 class="nav-link"-->
                <!--                 routerLink="/stores/salesGoalsType"-->
                <!--                 routerLinkActive="active">-->
                <!--                {{'Sales Goal Types' | translate}}-->
              <!--              </a>-->
              <!--              <a *ngIf="permissionService.hasPermission('CONTACT_VIEW') | async"-->
              <!--                 [routerLinkActiveOptions]="{exact: true}"-->
              <!--                 class="nav-link"-->
              <!--                 routerLink="/stores/contacts"-->
              <!--                 routerLinkActive="active">-->
              <!--                {{'Contacts' | translate}}-->
            <!--              </a>-->
          </div>
        </div>
        <!--          <div class="nav-link-wrapper">-->
        <!--            <a *ngIf="authenticationService.isNotAnAgent() && permissionService.hasPermission('ACTIVITY') | async"-->
        <!--               class="nav-link"-->
        <!--               routerLink="/batches/jobs"-->
        <!--               routerLinkActive="active">-->
        <!--              {{'Jobs' | translate}}-->
      <!--            </a>-->
      <!--            <div class="submenu">-->
      <!--              <a *ngIf="permissionService.hasPermission('ACTIVITY') | async"-->
      <!--                 [routerLinkActiveOptions]="{exact: true}"-->
      <!--                 class="nav-link"-->
      <!--                 routerLink="/batches/jobs"-->
      <!--                 routerLinkActive="active">-->
      <!--                {{'Jobs' | translate}}-->
    <!--              </a>-->
    <!--              <a *ngIf="permissionService.hasPermission('ACTIVITY') | async"-->
    <!--                 [routerLinkActiveOptions]="{exact: true}"-->
    <!--                 class="nav-link"-->
    <!--                 routerLink="/batches/clients"-->
    <!--                 routerLinkActive="active">-->
    <!--                {{'Clients' | translate}}-->
  <!--              </a>-->
  <!--              <a *ngIf="permissionService.hasPermission('ACTIVITY') | async"-->
  <!--                 [routerLinkActiveOptions]="{exact: true}"-->
  <!--                 class="nav-link"-->
  <!--                 routerLink="/batches/projects"-->
  <!--                 routerLinkActive="active">-->
  <!--                {{'Projects' | translate}}-->
<!--              </a>-->
<!--              <a *ngIf="permissionService.hasPermission('ACTIVITY') | async"-->
<!--                [routerLinkActiveOptions]="{exact: true}"-->
<!--                class="nav-link"-->
<!--                routerLink="/batches/batch-types"-->
<!--                routerLinkActive="active">-->
<!--              {{'Job Batch Types' | translate}}-->
<!--              </a>-->
<!--              <a *ngIf="permissionService.hasPermission('ACTIVITY') | async"-->
<!--                 [routerLinkActiveOptions]="{exact: true}"-->
<!--                 class="nav-link"-->
<!--                 routerLink="/batches"-->
<!--                 routerLinkActive="active">-->
<!--                {{'Jobs Batch' | translate}}-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
          <!--          <div class="nav-link-wrapper" *ngIf="authenticationService.isNotAnAgent() &&-->
          <!--          permissionService.hasAtLeastOnePermission('CALENDAR_VIEW', 'CALENDAR_MODIFY', 'OUT_OF_OFFICE_EVENT_MODIFY_RECEIVE_ALERTS',-->
          <!--          'OUT_OF_OFFICE_EVENT_VIEW', 'ACTIVITY_ADMIN', 'ACTIVITY', 'OUT_OF_OFFICE_EVENT_VIEW', 'STORE_VISIT_EVENT_TYPE_VIEW', 'OUT_OF_OFFICE_TYPE_VIEW') | async">-->

          <!--            <a *ngIf="permissionService.hasAtLeastOnePermission('CALENDAR_VIEW', 'CALENDAR_MODIFY', 'OUT_OF_OFFICE_EVENT_MODIFY_RECEIVE_ALERTS',-->
          <!--            'OUT_OF_OFFICE_EVENT_VIEW', 'ACTIVITY_ADMIN', 'ACTIVITY') | async; else noCalendar "-->
          <!--               routerLink="/calendar"-->
          <!--               class="nav-link" routerLinkActive="active">-->
          <!--              {{'Calendar' | translate}}-->
          <!--            </a>-->

          <!--            <ng-template #noCalendar>-->
          <!--              <a *ngIf="permissionService.hasPermission('OUT_OF_OFFICE_EVENT_VIEW') | async; else noOutOfOffice"-->
          <!--                 class="nav-link"-->
          <!--                 routerLink="/calendar/out-of-office"-->
          <!--                 routerLinkActive="active">-->
          <!--                {{'Calendar' | translate}}-->
          <!--              </a>-->
          <!--            </ng-template>-->

          <!--            <ng-template #noOutOfOffice>-->
          <!--              <a *ngIf="permissionService.hasPermission('STORE_VISIT_EVENT_TYPE_VIEW') | async;"-->
          <!--                 class="nav-link"-->
          <!--                 routerLink="/calendar/calendar-event-types"-->
          <!--                 routerLinkActive="active">-->
          <!--                {{'Calendar' | translate}}-->
          <!--              </a>-->
          <!--            </ng-template>-->

          <!--            <div class="submenu">-->
          <!--              <a *ngIf="permissionService.hasAtLeastOnePermission('CALENDAR_VIEW', 'CALENDAR_MODIFY', 'OUT_OF_OFFICE_EVENT_MODIFY_RECEIVE_ALERTS',-->
          <!--              'OUT_OF_OFFICE_EVENT_VIEW', 'ACTIVITY_ADMIN', 'ACTIVITY') | async"-->
          <!--                 [routerLinkActiveOptions]="{exact: true}"-->
          <!--                 class="nav-link"-->
          <!--                 routerLink="/calendar"-->
          <!--                 routerLinkActive="active">-->
          <!--                {{'Calendar' | translate}}-->
          <!--              </a>-->
          <!--              <a *ngIf="permissionService.hasPermission('OUT_OF_OFFICE_EVENT_VIEW') | async"-->
          <!--                 [routerLinkActiveOptions]="{exact: true}"-->
          <!--                 class="nav-link"-->
          <!--                 routerLink="/calendar/out-of-office"-->
          <!--                 routerLinkActive="active">-->
          <!--                {{'Out of Office' | translate}}-->
          <!--              </a>-->
          <!--              <a *ngIf="permissionService.hasAtLeastOnePermission('STORE_VISIT_EVENT_TYPE_VIEW', 'ACTIVITY', 'OUT_OF_OFFICE_TYPE_VIEW') | async"-->
          <!--                 [routerLinkActiveOptions]="{exact: true}"-->
          <!--                 class="nav-link"-->
          <!--                 routerLink="/calendar/calendar-event-types"-->
          <!--                 routerLinkActive="active">-->
          <!--                {{'Calendar Event Types' | translate}}-->
          <!--              </a>-->
          <!--            </div>-->
          <!--          </div>-->

          @if (authenticationService.isNotAnAgent() &&  permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY', 'ADHOC_VISIT_EDIT', 'STORE_VISIT_EDIT') | async) {
<div class="nav-link-wrapper"
              >

            @if (permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY') | async) {
<a
               class="nav-link"
        routerLink="/visits/adminForms"
        [class.active]="router.url.startsWith('/visits/adminForms') || router.url.startsWith('/visits/userForms') || router.url.startsWith('/visits/photos') || router.url.startsWith('/visits/photo-categories')">
        {{'Forms' | translate}}
      </a>
    } @else {
      @if (permissionService.hasAtLeastOnePermission('ADHOC_VISIT_EDIT', 'STORE_VISIT_EDIT') | async) {
        <a
          class="nav-link"
          routerLink="/visits/userForms"
          [class.active]="router.url.startsWith('/visits/adminForms') || router.url.startsWith('/visits/userForms') || router.url.startsWith('/visits/photos') || router.url.startsWith('/visits/photo-categories')">
          {{'Forms' | translate}}
        </a>
      }
    }
    <div class="submenu">
      @if (permissionService.hasAtLeastOnePermission('DYNAMIC_FORM_CREATE', 'DYNAMIC_FORM_MODIFY') | async) {
        <a
          class="nav-link"
          routerLink="/visits/adminForms"
          routerLinkActive="active">
          {{'Forms' | translate}}
        </a>
      } @else {
        @if (permissionService.hasAtLeastOnePermission('ADHOC_VISIT_EDIT', 'STORE_VISIT_EDIT') | async) {
          <a
            class="nav-link"
            routerLink="/visits/userForms"
            routerLinkActive="active">
            {{'Forms' | translate}}
          </a>
        }
      }
      @if (permissionService.hasPermission('PHOTOS_VIEW') | async) {
        <a
          class="nav-link"
          routerLink="/visits/photos"
          routerLinkActive="active">
          {{'Photos' | translate}}
        </a>
      }
      @if (permissionService.hasPermission('PHOTO_CATEGORIES_VIEW') | async) {
        <a
          class="nav-link"
          routerLink="/visits/photo-categories"
          routerLinkActive="active">
          {{'Photo Categories' | translate}}
        </a>
      }
    </div>
  </div>
}
@if (authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('ADHOC_VISIT_VIEW', 'STORE_VISIT_VIEW', 'ACTIVE_VISIT_VIEW') | async) {
  <div class="nav-link-wrapper"
    >
    <a class="nav-link"
               [routerLink]="(permissionService.hasPermission('ACTIVE_VISIT_VIEW') | async) ? '/visits/active-visits'
                : ((permissionService.hasPermission('ADHOC_VISIT_VIEW') | async) && (permissionService.hasPermission( 'STORE_VISIT_VIEW') | async) ? '/visits/all-visits'
                : ((permissionService.hasPermission('STORE_VISIT_VIEW') | async) ? '/visits'
                : '/visits/adhoc-forms'))"
      [class.active]="router.url.startsWith('/visits/active-visits') || router.url.startsWith('/visits/all-visits') || router.url.startsWith('/visits/adhoc-forms') || router.url === '/visits' || router.url.startsWith('/visits?')">
      {{'Visits' | translate}}
    </a>
    <div class="submenu">
      <!--              <a *ngIf="permissionService.hasPermission( 'ACTIVE_VISIT_VIEW') | async"-->
      <!--                  class="nav-link"-->
      <!--                  routerLink="/visits/active-visits"-->
      <!--                  routerLinkActive="active">-->
      <!--                {{'Active Visits' | translate}}-->
    <!--              </a>-->
    @if (permissionService.hasPermission('ADHOC_VISIT_VIEW') | async) {
      @if (permissionService.hasPermission( 'STORE_VISIT_VIEW') | async) {
        <a
          class="nav-link"
          routerLink="/visits/all-visits"
          routerLinkActive="active">
          {{'All Completed' | translate}}
        </a>
      }
    }
    <!--              <a *ngIf="permissionService.hasPermission('STORE_VISIT_VIEW') | async"-->
    <!--                class="nav-link"-->
    <!--                routerLink="/visits"-->
    <!--                [class.active]="router.url === '/visits' || router.url.startsWith('/visits?')">-->
    <!--                {{storeCompletedLabel | async}}-->
  <!--              </a>-->
  <!--              <a *ngIf="permissionService.hasPermission('ADHOC_VISIT_VIEW') | async"-->
  <!--                class="nav-link"-->
  <!--                routerLink="/visits/adhoc-forms"-->
  <!--                routerLinkActive="active">-->
  <!--                {{'AdHoc Completed' | translate}}-->
<!--              </a>-->
</div>
</div>
}
@if ((permissionService.hasPermission('VIBA_USER') | async)) {
  <div class="nav-link-wrapper"
    >
    <a class="nav-link"
      routerLink="/viba/agent"
      routerLinkActive="active">
      {{'VIBA Agent' | translate}}
    </a>
    <div class="submenu">
      @if (permissionService.hasPermission('VIBA_USER') | async) {
        <a
          [routerLinkActiveOptions]="{exact:  true}"
          class="nav-link"
          routerLink="/viba/agent/agent-live"
          routerLinkActive="active">
          {{'Live' | translate}}
        </a>
      }
    </div>
  </div>
}
@if ( authenticationService.isNotAnAgent() && permissionService.hasPermission('VIBA_ADMIN') | async) {
  <div class="nav-link-wrapper"
    >
    <a class="nav-link"
      routerLink="/viba/admin"
      routerLinkActive="active">
      {{'VIBA Admin' | translate}}
    </a>
    <div class="submenu">
      @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
        <a
          [routerLinkActiveOptions]="{exact:  true}"
          class="nav-link"
          routerLink="/viba/admin/agent-activity"
          routerLinkActive="active">
          {{'Agents' | translate}}
        </a>
      }
      @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
        <div class="nav-link-wrapper second-level-nav-link-wrapper">
          <a class="nav-link second-level-nav-link-wrapper__main-menu"
            [routerLinkActiveOptions]="{exact: false}"
            routerLink="/viba/admin/dialog-flow/batches"
            routerLinkActive="active">
            {{'Virtual Agent' | translate}}
            <mat-icon class="second-level-nav-link-wrapper__main-menu__right-arrow">arrow_right</mat-icon>
          </a>
          <div class="second-level-submenu">
            <!--                  <a [routerLinkActiveOptions]="{exact: false}"-->
            <!--                     class="nav-link"-->
            <!--                     routerLink="/viba/admin/dialog-flow/batches"-->
            <!--                     routerLinkActive="active">-->
            <!--                    {{'Batches' | translate}}-->
          <!--                  </a>-->
          <a [routerLinkActiveOptions]="{exact: false}"
            class="nav-link"
            routerLink="/viba/admin/dialog-flow/agent-configurations"
            routerLinkActive="active">
            {{'Configurations' | translate}}
          </a>
          <a [routerLinkActiveOptions]="{exact: false}"
            class="nav-link"
            routerLink="/viba/admin/dialog-flow/avatar"
            routerLinkActive="active">
            {{ 'Avatars' | translate }}
          </a>
        </div>
      </div>
    }
    @if (permissionService.hasPermission('VIBA_SNOOP') | async) {
      <a
        [routerLinkActiveOptions]="{exact:  true}"
        class="nav-link"
        routerLink="/viba/admin/agent-snooper"
        routerLinkActive="active">
        {{'Call Supervision' | translate}}
      </a>
    }
    <!--              <a *ngIf="permissionService.hasPermission('VIBA_ADMIN') | async"-->
    <!--                 [routerLinkActiveOptions]="{exact:  true}"-->
    <!--                 class="nav-link"-->
    <!--                 routerLink="/viba/admin/schedules"-->
    <!--                 routerLinkActive="active">-->
    <!--                {{'Schedules' | translate}}-->
  <!--              </a>-->
  @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
    <a
      [routerLinkActiveOptions]="{exact:true}"
      class="nav-link"
      routerLink="/viba/admin/clients"
      routerLinkActive="active">
      {{'Clients' | translate}}
    </a>
  }
  @if (permissionService.hasAtLeastOnePermission('BRAND_VIEW', 'VIBA_ADMIN') | async) {
    <a
      [routerLinkActiveOptions]="{exact: true}"
      class="nav-link"
      routerLink="/viba/admin/brands"
      routerLinkActive="active">
      {{'Brands' | translate }}
    </a>
  }
  @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
    <a
      [routerLinkActiveOptions]="{exact:true}"
      class="nav-link"
      routerLink="/viba/admin/projects"
      routerLinkActive="active">
      {{'Projects' | translate}}
    </a>
  }
  @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
    <a
      [routerLinkActiveOptions]="{exact:true}"
      class="nav-link"
      routerLink="/viba/admin/devices"
      routerLinkActive="active">
      {{'Devices' | translate}}
    </a>
  }
  <div class="nav-link-wrapper second-level-nav-link-wrapper">
    <a class="nav-link second-level-nav-link-wrapper__main-menu"
      [routerLinkActiveOptions]="{exact:false}"
      routerLinkActive="active"
      routerLink="/viba/admin/endpoints"
      >
      {{'Endpoints' | translate}}
      <mat-icon class="second-level-nav-link-wrapper__main-menu__right-arrow">arrow_right</mat-icon>
    </a>
    <div class="second-level-submenu">
      <!--                  <a *ngIf="permissionService.hasPermission('VIBA_ADMIN') | async"-->
      <!--                    [routerLinkActiveOptions]="{exact: false}"-->
      <!--                    class="nav-link"-->
      <!--                    routerLink="/viba/admin/endpoints/smart-signs"-->
      <!--                    routerLinkActive="active">-->
      <!--                    {{'Smart Signs' | translate}}-->
    <!--                  </a>-->
    @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
      <a
        [routerLinkActiveOptions]="{exact: false}"
        class="nav-link"
        routerLink="/viba/admin/endpoints/qrcodes"
        routerLinkActive="active">
        {{'QR Codes' | translate}}
      </a>
    }
    @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
      <a
        [routerLinkActiveOptions]="{exact: false}"
        class="nav-link"
        routerLink="/viba/admin/endpoints/weblinks"
        routerLinkActive="active">
        {{'Weblinks' | translate}}
      </a>
    }
  </div>
</div>
@if (permissionService.hasPermission('VIBA_ADMIN') | async) {
  <a
    [routerLinkActiveOptions]="{exact: true}"
    class="nav-link"
    routerLink="/viba/admin/content"
    routerLinkActive="active">
    {{'Content' | translate}}
  </a>
}
<div class="nav-link-wrapper second-level-nav-link-wrapper">
  <a class="nav-link second-level-nav-link-wrapper__main-menu"
    [routerLinkActiveOptions]="{exact:false}"
    routerLinkActive="active"
    routerLink="/viba/admin/products">
    {{'Products' | translate}}
    <mat-icon class="second-level-nav-link-wrapper__main-menu__right-arrow">arrow_right</mat-icon>
  </a>
  <div class="second-level-submenu">
    @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
      <a
        [routerLinkActiveOptions]="{exact: false}"
        class="nav-link"
        routerLink="/viba/admin/products/products"
        routerLinkActive="active">
        {{'Products' | translate}}
      </a>
    }
    @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
      <a
        [routerLinkActiveOptions]="{exact: false}"
        class="nav-link"
        routerLink="/viba/admin/products/product-categories"
        routerLinkActive="active">
        {{'Product Categories' | translate}}
      </a>
    }
    @if (permissionService.hasPermission('VIBA_ADMIN') | async) {
      <a
        [routerLinkActiveOptions]="{exact: false}"
        class="nav-link"
        routerLink="/viba/admin/products/product-types"
        routerLinkActive="active">
        {{'Product Types' | translate}}
      </a>
    }
  </div>
</div>
@if (permissionService.hasPermission('VIBA_ADMIN') | async) {
  <a
    [routerLinkActiveOptions]="{exact: true}"
    class="nav-link"
    routerLink="/viba/admin/product-scraper"
    routerLinkActive="active">
    {{'Product Scraper' | translate}}
  </a>
}
@if (permissionService.hasPermission('VIBA_ADMIN') | async) {
  <div class="nav-link-wrapper second-level-nav-link-wrapper">
    <a class="nav-link second-level-nav-link-wrapper__main-menu"
      [routerLinkActiveOptions]="{exact: true}"
      class="nav-link"
      routerLink="/viba/admin/queues"
      routerLinkActive="active">
      {{'Queues' | translate}}
      <mat-icon class="second-level-nav-link-wrapper__main-menu__right-arrow">arrow_right</mat-icon>
    </a>
    <div class="second-level-submenu">
      <a [routerLinkActiveOptions]="{exact: true}"
        class="nav-link"
        routerLink="/viba/admin/queues"
        routerLinkActive="active">
        {{'Queues' | translate}}
      </a>
      <a [routerLinkActiveOptions]="{exact: true}"
        class="nav-link"
        routerLink="/viba/admin/queues/incoming-calls"
        routerLinkActive="active">
        {{'Incoming Calls' | translate}}
      </a>
    </div>
  </div>
}
    </div>
  </div>
}
<!--          <div class="nav-link-wrapper">-->
<!--            <a *ngIf="authenticationService.isNotAnAgent() && permissionService.hasAtLeastOnePermission('SALES_GOALS_IMPORT', 'USERS_IMPORT') | async"-->
<!--               class="nav-link" routerLink="/imports/imports" routerLinkActive="active">-->
<!--              {{'Imports' | translate}}-->
<!--            </a>-->
<!--            <div class="submenu">-->
<!--              <a *ngIf="permissionService.hasAtLeastOnePermission('SALES_GOALS_IMPORT', 'USERS_IMPORT') | async"-->
<!--                 [routerLinkActiveOptions]="{exact: true}"-->
<!--                 class="nav-link"-->
<!--                 routerLink="/imports/imports"-->
<!--                 routerLinkActive="active">-->
<!--                {{'Imports' | translate}}-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
</div>
}
@if (authenticationService.showNavigation()) {
  <div class="right">
    <app-switch-language ></app-switch-language>
    @if (authenticationService.isNotAnAgent() && authenticationService.organizations.length > 1) {
      <form [formGroup]="organizationForm" novalidate
        class="organization-switch">
        <mat-form-field appearance="fill">
          <mat-select formControlName="activeOrganization"
            [matTooltip]="'Active Organization' | translate"
            placeholder="">
            @for (organization of authenticationService.organizations; track organization) {
              <mat-option [value]="organization.id">
                {{organization.orgName}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    }
    <button mat-icon-button [matMenuTriggerFor]="userSettingsMenu"  type="button">
      @if (whatsNewHighlighting) {
        <mat-icon [matBadge]="1" matBadgePosition="above after" matBadgeSize="small" matBadgeColor="warn" matBadgeOverlap="true"> menu </mat-icon>
      }
      @if (!whatsNewHighlighting) {
        <mat-icon> menu </mat-icon>
      }
    </button>
    <mat-menu #userSettingsMenu="matMenu">
      <span class="loggedInText">{{loggedInMessage$ | async}}</span>
      @if (!authenticationService.isEmbeddedAgent) {
        <button mat-menu-item
          [routerLinkActiveOptions]="{exact: true}"
          routerLink="/users/change-password"
          routerLinkActive="active">
          <mat-icon>published_with_changes</mat-icon>
          <span>{{'Change Password' | translate}}</span>
        </button>
      }
      @if (whatsNewMenuDisplay) {
        <button mat-menu-item (click)="viewWhatsNew()" id="whats-new">
          <mat-icon [svgIcon]="(whatsNewHighlighting ? 'bellBadge' : 'bell')"></mat-icon>
          <span>{{"What's New" | translate}}</span>
        </button>
      }
      @if (authenticationService.isNotAnAgent()) {
        <button mat-menu-item
          (click)="onCreateHelpdeskTicket()">
          <mat-icon>headset_mic</mat-icon>
          <span>{{'Create a Help Desk Ticket' | translate}}</span>
        </button>
      }
      @if (authenticationService.isLoggedIn && !authenticationService.isEmbeddedAgent) {
        <button mat-menu-item (click)="logout()">
          <mat-icon>input</mat-icon>
          <span>{{'Log Out' | translate}}</span>
        </button>
      }
    </mat-menu>
  </div>
}
@if (!authenticationService.showNavigation()) {
  <div class="right">
    <button mat-icon-button [matMenuTriggerFor]="userSettingsMenu"  type="button">
      @if (whatsNewHighlighting) {
        <mat-icon [matBadge]="1" matBadgePosition="above after" matBadgeSize="small" matBadgeColor="warn" matBadgeOverlap="true"> menu </mat-icon>
      }
      @if (!whatsNewHighlighting) {
        <mat-icon> menu </mat-icon>
      }
    </button>
    <mat-menu #userSettingsMenu="matMenu">
      <span class="loggedInText">{{loggedInMessage$ | async}}</span>
      @if (authenticationService.isLoggedIn && !authenticationService.isEmbeddedAgent) {
        <button mat-menu-item (click)="logout()">
          <mat-icon>input</mat-icon>
          <span>{{'Log Out' | translate}}</span>
        </button>
      }
    </mat-menu>
  </div>
}
</div>
<div class="header__navigation--mobile">
  @if (!authenticationService.isEmbeddedAgent) {
    <button mat-icon-button (click)="openMenu.emit()" >
      @if (whatsNewHighlighting) {
        <mat-icon [matBadge]="1" matBadgePosition="above after" matBadgeSize="small" matBadgeColor="warn" matBadgeOverlap="true"> menu </mat-icon>
      }
      @if (!whatsNewHighlighting) {
        <mat-icon> menu </mat-icon>
      }
    </button>
  }
</div>
</div>
</mat-toolbar-row>
</mat-toolbar>
}
